import react from "react";

export default function Saveicon() {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3627 14.6227L8.66085 11.2643L3.95898 14.6227V3.87562C3.95898 3.51933 4.10052 3.17763 4.35245 2.9257C4.60439 2.67376 4.94609 2.53223 5.30238 2.53223H12.0193C12.3756 2.53223 12.7173 2.67376 12.9692 2.9257C13.2212 3.17763 13.3627 3.51933 13.3627 3.87562V14.6227Z" stroke="white" strokeWidth="1.00754" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}